import { Injectable } from "@angular/core";
import {
    CanActivate,
    CanActivateChild,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { NotificacionesService } from "../rest/notificaciones.service";
import { MenuUsuarioService } from "../util/menu-usuario.service";

@Injectable({
    providedIn: "root",
})
export class RoleGuardService implements CanActivate, CanActivateChild {
    constructor(
        private _menuUsuarioSrvc: MenuUsuarioService,
        private router: Router,
        private _notificacionSrvc: NotificacionesService
    ) {}
    async canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        const allowedRoles = next.data.allowedRoles;
        const isAuthorized = await this._menuUsuarioSrvc.estaAutorizado(
            allowedRoles
        );

        if (!isAuthorized) {
            this._notificacionSrvc.mostrarNotificacion(
                "No autorizado.",
                "error"
            );
            this.router.navigate(["inicio"]);
        }

        return isAuthorized;
    }
    async canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        const allowedRoles = next.data.allowedRoles;
        const isAuthorized = await this._menuUsuarioSrvc.estaAutorizado(
            allowedRoles
        );

        if (!isAuthorized) {
            this._notificacionSrvc.mostrarNotificacion(
                "No autorizado",
                "error"
            );
            this.router.navigate(["inicio"]);
        }

        return isAuthorized;
    }
}
